import { render, staticRenderFns } from "./OrdersSection.vue?vue&type=template&id=38e13a63"
import script from "./OrdersSection.vue?vue&type=script&lang=js"
export * from "./OrdersSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports